import { DestroyRef, Directive, ElementRef, Renderer2 } from '@angular/core';
import { SettingsService } from '../services/settings.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({
  selector: '[appSpeechBubbleText]',
})
export class SpeechBubbleTextDirective {
  constructor(
    el: ElementRef, 
    renderer: Renderer2, 
    settings: SettingsService,
    destroyRef: DestroyRef
  ) {
    // Update font-size
    settings.fontSize$
      .pipe(takeUntilDestroyed(destroyRef))
      .subscribe(x => el.nativeElement.style.fontSize = `${1 + x / 100}em`);

    // Update font-weight
    settings.fontWeight$
      .pipe(takeUntilDestroyed(destroyRef))
      .subscribe(weight => el.nativeElement.style.fontWeight = weight.toString());

    // Update lang
    settings.localLanguageOut$
      .pipe(takeUntilDestroyed(destroyRef))
      .subscribe(language => renderer.setAttribute(el.nativeElement, 'lang', language));
  }
}
